import api from './api';

// ChatGPT Ads (OpenAI) — conexão por API key (sem OAuth).
// O X-Project-ID vai automático pelo interceptor do api.ts.
// Listagem/desconexão usam os fluxos genéricos já existentes
// (socialService.getAccountsWithAds / disconnectOAuth('openai_ads')).
export const openaiAdsService = {
  // Valida a key na OpenAI e salva no projeto atual
  connect: async (apiKey: string) => {
    const response = await api.post('/openai-ads/connect', { api_key: apiKey });
    return response.data;
  },
};

export default openaiAdsService;
